/**
 * Smooth scrolls to a specific point
 */

function easeInOut(currTime, start, change, duration) {
  let currentTime = currTime;
  currentTime /= duration / 2;
  if (currentTime < 1) {
    // eslint-disable-next-line
    return (change / 2) * currentTime * currentTime + start;
  }
  currentTime -= 1;
  // eslint-disable-next-line
  return (-change / 2) * (currentTime * (currentTime - 2) - 1) + start;
}

export function animateScroll(elTime, scrollTarget, speed) {
  const start = window.pageYOffset;
  const change = scrollTarget - start;
  const increment = 20;
  let elapsedTime = elTime;
  elapsedTime += increment;
  const position = easeInOut(elapsedTime, start, change, speed);
  window.scrollTo(0, position);
  if (elapsedTime < speed) {
    setTimeout(() => {
      animateScroll(elapsedTime, scrollTarget, speed);
    }, increment);
  }
}

function smoothScrollTo(target, speed) {
  const scrollTarget = target.getBoundingClientRect().top;
  animateScroll(0, scrollTarget, speed);
}

export default smoothScrollTo;
